import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { getPortfolioCategory } from '../../api'
import ProductShowcase from './ProductShowcase'

function Co2tankstorage() {
  const [products, setProducts] = useState([])

  useEffect(() => {
    getPortfolioCategory('co2_tank').then(setProducts).catch(() => {})
  }, [])

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>CO₂ / N₂O Tank Storage</Typography>
          <Typography className='page-subtitle'>
            Refrigeration units that maintain CO₂ pressure in storage tanks.
          </Typography>
        </div>

        <div className='page-stack'>
          {products.map((p, i) => (
            <ProductShowcase
              key={i}
              title={p.specs.name}
              images={p.image_paths}
              specs={[
                { label: 'Location', value: p.specs.location },
                { label: 'Tank capacity', value: p.specs.tankCapacity },
                { label: 'Refrigerant', value: p.specs.refrigerant },
                { label: 'Heat exchanger', value: p.specs.heatExchanger },
              ]}
              badges={[
                p.specs.water_cooled_condenser && 'Water-cooled condenser',
                p.specs.remote && 'Smartphone / PC control',
              ]}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Co2tankstorage
